import { ReactElement } from "react";
import { IMeasureSummary } from "../../../../services/http/measure/models/IMeasureSummary";
import { MeasureSummary } from "../../../../services/http/measure/models/MeasureSummary";
import ProductionNumber from "./ProductionNumber";
import ProductionFact from "./ProductionFact";
import styles from './Production.module.scss';

const Production = (): ReactElement =>
{
    function loadMock(): IMeasureSummary
    {
        const measureSummary = new MeasureSummary();
        measureSummary.currentValue = 932.12;
        measureSummary.historicMeasure.average = 1116.75;

        return measureSummary;
    }

    const measureSummaryData = loadMock();

    // TODO: remove hardcoding
    const productionTarget = Math.floor(Math.random() * 2) === 1
        ? measureSummaryData.currentValue + measureSummaryData.currentValue * 0.1
        : measureSummaryData.currentValue - measureSummaryData.currentValue * 0.3;

    const difference = measureSummaryData.currentValue - productionTarget;

    const average = `${measureSummaryData.historicMeasure.average} bpd`;
    const rankingLevel = `${Math.floor(Math.random() * 80) + 1} / 80`;

    return (
        <>
            <div className={styles.comparison}>
                <ProductionNumber label="Barrels per day" value={measureSummaryData.currentValue} difference={difference} displayIcon />
                <ProductionNumber label="Production target" value={productionTarget} difference={null} displayIcon={false} />
            </div>

            <div className={styles.facts}>
                <ProductionFact label="Production average" value={average} />
                <ProductionFact label="Well ranking" value={rankingLevel} />
            </div>
        </>
    );
}

export default Production;